import { api } from './api';

export interface Impuesto {
  id: number;
  tenantId: number;
  name: string;
  porcentaje: number;
  tipo: 'iva' | 'ieps' | 'ish' | 'otro';
  aplicaA: 'productos' | 'servicios' | 'todos';
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ImpuestoCreate {
  name: string;
  porcentaje: number;
  tipo?: 'iva' | 'ieps' | 'ish' | 'otro';
  aplicaA?: 'productos' | 'servicios' | 'todos';
}

export interface ImpuestoUpdate {
  name?: string;
  porcentaje?: number;
  tipo?: 'iva' | 'ieps' | 'ish' | 'otro';
  aplicaA?: 'productos' | 'servicios' | 'todos';
  isActive?: boolean;
}

export interface CalculoImpuestos {
  subtotal: number;
  impuestos: Array<{
    impuestoId: number;
    name: string;
    tipo: string;
    porcentaje: number;
    monto: number;
  }>;
  totalImpuestos: number;
  total: number;
}

export const impuestoService = {
  getAll: async (): Promise<{ data: { impuestos: Impuesto[] } }> => {
    const response = await api.get<{ data: { impuestos: Impuesto[] } }>('/impuestos');
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { impuesto: Impuesto } }> => {
    const response = await api.get<{ data: { impuesto: Impuesto } }>(`/impuestos/${id}`);
    return response.data;
  },

  calcular: async (subtotal: number, tipoProducto?: string): Promise<{ data: CalculoImpuestos }> => {
    const response = await api.post<{ data: CalculoImpuestos }>('/impuestos/calcular', {
      subtotal,
      tipoProducto
    });
    return response.data;
  },

  create: async (data: ImpuestoCreate): Promise<{ data: { impuesto: Impuesto } }> => {
    const response = await api.post<{ data: { impuesto: Impuesto } }>('/impuestos', data);
    return response.data;
  },

  update: async (id: number, data: ImpuestoUpdate): Promise<{ data: { impuesto: Impuesto } }> => {
    const response = await api.put<{ data: { impuesto: Impuesto } }>(`/impuestos/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/impuestos/${id}`);
    return response.data;
  }
};

